var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./spinner.module.css";
export function Spinner(_a) {
    var _b = _a.size, size = _b === void 0 ? "30px" : _b, rest = __rest(_a, ["size"]);
    return (_jsx("div", __assign({}, rest, { className: classNames(styles["spinner"]), style: {
            width: size,
        }, children: _jsx("svg", { className: classNames(styles["circular"]), viewBox: "25 25 50 50", children: _jsx("circle", { className: classNames(styles["path"]), cx: "50", cy: "50", r: "20", fill: "none", strokeWidth: "4", strokeMiterlimit: "10" }) }) })));
}
